import { getEnvironment } from "./runtime";

/**
 * Every value the browser is allowed to know about.
 *
 * Anything secret (Google client secret, Cosmos keys, function host keys) lives
 * in dave-service and never reaches a bundle. Admin data is read through
 * `/api/admin/*` on dave-service, which authorises the caller server-side, so
 * the admin bundle carries no API key at all.
 */
export interface AppConfig {
  /** Which deployment slot we resolved to. */
  environment: ReturnType<typeof getEnvironment>;

  /** Public quote API base for this deployed environment. */
  publicApiUrl: string;

  /** Admin API base. Same-origin (`/api`) in normal deployments. */
  adminApiUrl: string;

  /** Public quote screen origin, linked to from the admin quotes table. */
  publicQuoteScreenUrl: string;

  /** WordPress fast-food step form embedded by the admin fast-food screen. */
  fastFoodFormUrl: string;

  /** Render the public screen from bundled sample data instead of the API. */
  useSampleData: boolean;

  supportPhone: string;
}

const env = import.meta.env;

export const appConfig: AppConfig = {
  environment: getEnvironment(),

  publicApiUrl: (env.VITE_API_URL ?? "").replace(/\/$/, ""),

  adminApiUrl: (env.VITE_ADMIN_API_URL ?? "/api").replace(/\/$/, ""),

  publicQuoteScreenUrl: (env.VITE_QUOTE_URL ?? "").replace(/\/$/, ""),

  fastFoodFormUrl: (env.VITE_FAST_FOOD_URL ?? "").trim(),

  useSampleData: env.VITE_USE_SAMPLE_DATA === "true",

  supportPhone: env.VITE_SUPPORT_PHONE ?? "0330 808 9057",
};

export const brand = {
  name: "Insurance Revolution",
  shortName: "IR",
  logoUrl:
    "https://www.insurancerevolution.co.uk/wp-content/uploads/2024/03/header_logo.png",
  websiteUrl: "https://www.insurancerevolution.co.uk",
} as const;

export { getEnvironment };
